import {Tr} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import {ArtifactNavPanel} from "@/scenes.ui/artifact-nav-panel";
import {Artifact} from "@/store/artifact/types";
import {Creature} from "@/store/level/types";
import {CreaturePickArtifactBonusPanel} from "@/scenes.ui/creature-pick-artifact-bonus-panel";
import {SquareButton} from "@/scenes.ui/square-button";
import SoundUtils from "@/utils/sound-utils";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class ArtifactReforgePanel extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, creatures: Creature[], onRefineCallback: (artifactId: number, creatureId: number) => unknown,
                isUsed: boolean) {
        super(scene, canvas, Tr('kuznitsa'));

        let icon = SpriteUtils.addImage(scene, 0,-150, Keys.ATLAS_PROFILE, Keys.IMG_ANVIL);

        const clickSound = SoundUtils.addSound(scene, Keys.SOUND_SELECT);

        this.add(icon);

        if (isUsed) {
            let title = TextUtils.addTextByFamily(scene, Tr('ustavshiy.magkuznets.proiznosit'),
                0, icon.y / CU.S + 100, '#ffffff', 16, 'normal', 400, Fonts.MYRIADPRO_REGULAR);

            let okButton = new SquareButton(this.scene, 0, 155, 0, Keys.UI_ART_GREEN_BUTTON,
                Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, Tr('horosho'), false, 0, 0, 46);

            okButton.setCallback(() => {
                if (this.isOnTop()) {
                    SoundUtils.play(clickSound);
                    this.close();
                }
            });

            this.add([title, okButton]);
            return;
        }

        let title = TextUtils.addTextByFamily(scene, Tr('snachala.viberite.artefakt.dlja.perekovki.'),
            0, icon.y / CU.S + 100, '#ffd465', 16, 'normal', 450, Fonts.MYRIADPRO_REGULAR);

        let info = TextUtils.addTextByFamily(scene,
            Tr('vibranniy.artefakt.budet.razobran'),
            0, title.getBottomCenter().y! / CU.S + 60, '#b3b3b3', 13, 'normal', 350, Fonts.MYRIADPRO_REGULAR);


        let arts: Artifact[] = [];
        let crNameByArtId: Map<number, string> = new Map<number, string>();
        creatures.forEach((c: Creature) => {
            arts.push(...c.artifacts);
            c.artifacts.forEach(a => {
                crNameByArtId.set(a.id, c.name);
            });
        });

        let artsSortedDesc = Object.assign([], arts).sort((a: Artifact, b: Artifact) => {
            return a.effectValue - b.effectValue;
        });

        let artifactNavPanel: ArtifactNavPanel = new ArtifactNavPanel(scene, canvas, 0, 0, artsSortedDesc, crNameByArtId, (artifact: Artifact) => {
            new CreaturePickArtifactBonusPanel(scene, canvas, creatures, artifact, (artifactId: number, creatureId: number) => {
                if (onRefineCallback != null) {
                    this.close();
                    onRefineCallback(artifactId, creatureId);
                }
            }).open();
        });

        this.add([title, info, artifactNavPanel]);
    }


}
